import { styled } from '@mui/material';

import {
  useGetOrganizationSimulationStatisticsQuery,
} from '@app-velocity/modules/teams';
import { Card, Modal, Skeleton } from '@app-velocity/ui';
import { useGetTeamsQuery } from '@app-velocity/libs/teams-data-access';

import { OrgUsageContext } from './context/OrgUsageContext';
import { UsageStats } from './components/UsageStats';
import { UsageProgress } from './components/UsageProgress';
import { ByTeam } from './components/ByTeam';

const SummaryCard = styled(Card)(({ theme }) => ({
  gap: theme.spacing(4),
  display: 'flex',
  padding: theme.spacing(4),
  flexDirection: 'column',
}));

export const OrgUsage = () => {
  const { isLoading: areTeamsLoading, data: myTeams } = useGetTeamsQuery();

  const teamWithMyOrganization = myTeams?.find((team) => !!team.organizationId);
  const { isLoading: areStatsLoading, data: simStatsByTeam } =
    useGetOrganizationSimulationStatisticsQuery(
      teamWithMyOrganization?.organizationId || ''
    );

  const isLoading = areTeamsLoading || areStatsLoading;

  return (
    <OrgUsageContext.Provider
      value={{
        simStatsByTeam: simStatsByTeam || null,
      }}
    >
      <Modal.Header title="teams:org_usage.title" />
      <Modal.Content>
        {isLoading ? (
          <>
            <Skeleton height={137} margin="0" borderRadius={2} />
            <Skeleton height={50} margin="0" borderRadius={1} />
          </>
        ) : (
          <>
            <SummaryCard>
              <UsageStats />
              <UsageProgress />
            </SummaryCard>
            <ByTeam />
          </>
        )}
      </Modal.Content>
    </OrgUsageContext.Provider>
  );
};
